/* data structures for trend analysis */
import {DateTime, Interval} from "luxon"
import { dateFormat } from "../../timeFunctions/timeFns"

export function trendInterval(jsDate, duration, compare) {
  const dtStart = DateTime.fromJSDate(jsDate)
  const dtEnd = dtStart.plus(duration)
  const dtPrevStart = dtStart.minus(compare)
  const dtPrevEnd = dtPrevStart.plus(duration)
  return ({
    prev: Interval.fromDateTimes(dtPrevStart, dtPrevEnd),
    later: Interval.fromDateTimes(dtStart, dtEnd),
    duration: {...duration},
    ago: {...compare},
  })
}
export function tiUpdate(ti, duration) {
  ti.prev.e = ti.prev.s.plus(duration)
  ti.later.e = ti.later.s.plus(duration)
  ti.duration = duration
  return ti
}
export function tiRebase(ti, date) {
  const dtStart = DateTime.fromJSDate(date)
  const dtEnd = dtStart.plus(ti.duration)
  const dtPrevStart = dtStart.minus(ti.ago)
  const dtPrevEnd = dtPrevStart.plus(ti.duration)
  ti.prev = Interval.fromDateTimes(dtPrevStart, dtPrevEnd)
  ti.later = Interval.fromDateTimes(dtStart, dtEnd)
  return ti
}
export function tiExtent (ti, ago) {
  const dtPrevStart = ti.later.s.minus(ago)
  const dtPrevEnd = dtPrevStart.plus(ti.duration)
  ti.prev = Interval.fromDateTimes(dtPrevStart, dtPrevEnd)
  ti.ago = ago
  return ti
}
export function tiToString (ti) {
  return [intervalToString('later', ti), intervalToString('prev', ti)]
}
function intervalToString (intName, ti) {
  return (
    Object.values(ti.duration)[0]+' '+Object.keys(ti.duration)[0] +
      ' starting '+dateFormat(ti[intName].s)
  )
} 
export function arrApiAdapter (arrApi) {
  return arrApi.map(api => deviceApiAdapter(api))
}
function deviceApiAdapter(apiData) {
  const wanted = apiData?.data?.data?.readings
  // console.log(wanted) // runs too often?
  return wanted.map((r) => (
    {readTime: r.read_time, 
     readings: r.values.map((v) => (
      {sensorType: Object.keys(v)[0], value:Object.values(v)[0]})),
  }))
}

